import { Icon as PhosphorIcon } from '@phosphor-icons/react';
import { Icon, IconKey } from '@sr/ui-library';
import { twMerge } from 'tailwind-merge';

interface IconWithCircleBackgroundProps {
  className?: string;
  color: string;
  icon: IconKey | PhosphorIcon;
  iconClassName?: string;
  iconColor?: string;
  size?:
    | '!default'
    | '!lg'
    | '!sm'
    | '!xs'
    | 'default'
    | 'default'
    | 'lg'
    | 'sm'
    | 'xs';
}

const IconWithCircleBackground = ({
  className,
  color,
  icon,
  iconClassName,
  iconColor = 'text-black',
  size = 'xs',
  ...restProps
}: IconWithCircleBackgroundProps) => {
  return (
    <div
      className={twMerge(
        'flex h-7 w-7 items-center justify-center rounded-full',
        color,
        className,
      )}
    >
      <Icon
        className={twMerge(iconColor, iconClassName)}
        icon={icon}
        size={size}
        {...restProps}
      />
    </div>
  );
};

export default IconWithCircleBackground;
